import React, { useContext, useState } from 'react';
import { Row, Col, Card, Spin, Select, DatePicker } from 'antd';
import LineChart from 'src/components/chart/LineChart';
import ivSurfaceChart from 'src/components/chart/configs/ivSurfaceChart';
import ivSkewChart from 'src/components/chart/configs/ivSkewChart';
import { DateContext } from 'src/components/layout/Main';
import {
  getAtmIv,
  getIvSkew,
  getIvSurface,
  getIvTermStructure,
} from 'src/services/analytics.service';
import { useQuery } from '@tanstack/react-query';
import { formatDate } from 'src/utils/util';
import ivTermStructureChart from 'src/components/chart/configs/ivTermStructureChart';

function Analytics() {
  const { timeRange } = useContext(DateContext);
  const [currency, setCurrency] = useState('BTC');
  const [ivSurfacePricingDate, setIvSurfacePricingDate] = useState(
    timeRange[1]
  );
  const [ivTermStructurePricingDate, setIvTermStructurePricingDate] = useState(
    timeRange[1]
  );

  const { data: ivSurfaceData, isLoading: ivSurfaceLoading } = useQuery({
    queryKey: [
      'ivSurface',
      { currency, pricing_date: formatDate(ivSurfacePricingDate) },
    ],
    queryFn: getIvSurface,
  });

  const { data: ivSkewData, isLoading: ivSkewLoading } = useQuery({
    queryKey: [
      'ivSkew',
      {
        currency,
        start_date: formatDate(timeRange[0]),
        end_date: formatDate(timeRange[1]),
      },
    ],
    queryFn: getIvSkew,
  });

  const { data: ivTermStructureData, isLoading: ivTermStructureLoading } =
    useQuery({
      queryKey: [
        'ivTermStructure',
        {
          currency,
          pricing_date: formatDate(ivTermStructurePricingDate),
        },
      ],
      queryFn: getIvTermStructure,
    });

  const { data: atmIvData, isLoading: atmIvLoading } = useQuery({
    queryKey: [
      'atmIv',
      {
        currency,
        start_date: formatDate(timeRange[0]),
        end_date: formatDate(timeRange[1]),
      },
    ],
    queryFn: getAtmIv,
  });

  return (
    <>
      <div className='layout-content'>
        <Row gutter={[24, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className='mb-24'>
            <Spin spinning={ivSurfaceLoading} tip='Loading...'>
              <Card bordered={false} className='criclebox h-full'>
                <LineChart
                  title='IV Surface'
                  series={ivSurfaceData?.result}
                  options={ivSurfaceChart.options}
                  topRightChildren={
                    <>
                      <Row gutter={[8, 0]}>
                        <Col>
                          <Select
                            value={currency}
                            onChange={setCurrency}
                            options={[{ label: 'BTC', value: 'BTC' }]}
                          />
                        </Col>
                        <Col>
                          <DatePicker
                            value={ivSurfacePricingDate}
                            onChange={(date) => {
                              setIvSurfacePricingDate(
                                date.utc().minute(0).second(0)
                              );
                            }}
                            showTime
                          />
                        </Col>
                      </Row>
                    </>
                  }
                />
              </Card>
            </Spin>
          </Col>
        </Row>

        <Row gutter={[24, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className='mb-24'>
            <Spin spinning={ivSkewLoading} tip='Loading...'>
              <Card bordered={false} className='criclebox h-full'>
                <LineChart
                  title='IV Skew'
                  series={ivSkewData?.result}
                  options={ivSkewChart.options}
                  topRightChildren={
                    <Select
                      value={currency}
                      onChange={setCurrency}
                      options={[{ label: 'BTC', value: 'BTC' }]}
                    />
                  }
                />
              </Card>
            </Spin>
          </Col>
        </Row>

        <Row gutter={[24, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className='mb-24'>
            <Spin spinning={ivTermStructureLoading} tip='Loading...'>
              <Card bordered={false} className='criclebox h-full'>
                <LineChart
                  title='IV Term Structure'
                  series={ivTermStructureData?.result}
                  options={ivTermStructureChart.options}
                  topRightChildren={
                    <>
                      <Row gutter={[8, 0]}>
                        <Col>
                          <Select
                            value={currency}
                            onChange={setCurrency}
                            options={[{ label: 'BTC', value: 'BTC' }]}
                          />
                        </Col>
                        <Col>
                          <DatePicker
                            value={ivTermStructurePricingDate}
                            onChange={(date) => {
                              setIvTermStructurePricingDate(
                                date.utc().minute(0).second(0)
                              );
                            }}
                            showTime
                          />
                        </Col>
                      </Row>
                    </>
                  }
                />
              </Card>
            </Spin>
          </Col>
        </Row>

        <Row gutter={[24, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className='mb-24'>
            <Spin spinning={atmIvLoading} tip='Loading...'>
              <Card bordered={false} className='criclebox h-full'>
                <LineChart
                  title='ATM IV'
                  series={atmIvData?.result}
                  options={ivSkewChart.options}
                  topRightChildren={
                    <Select
                      value={currency}
                      onChange={setCurrency}
                      options={[{ label: 'BTC', value: 'BTC' }]}
                    />
                  }
                />
              </Card>
            </Spin>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Analytics;
